import { c as _c } from "react/compiler-runtime";
import { Divider, MenuItem, Select, type SelectProps } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';
import React, { useMemo } from 'react';
import { PropertyPolicyRelation, type FilterProperty } from '@/types/advanceFilter';
import { OPERATORS } from './OperatorSelect';
import { inlineDropdownStyle } from './conditionComponents';
interface PropertySelectProps {
  condition?: Condition;
  properties: FilterProperty[][];
  onChange: (condition: Condition) => void;
}
export function PropertySelect(t0) {
  const $ = _c(24);
  let condition;
  let onChange;
  let properties;
  let props;
  if ($[0] !== t0) {
    ({
      condition,
      properties,
      onChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = condition;
    $[2] = onChange;
    $[3] = properties;
    $[4] = props;
  } else {
    condition = $[1];
    onChange = $[2];
    properties = $[3];
    props = $[4];
  }
  condition?.property;
  let t1;
  if ($[5] !== condition?.property || $[6] !== properties) {
    let t2;
    if ($[8] !== condition?.property) {
      t2 = c => c.name === condition?.property;
      $[8] = condition?.property;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = properties.flat().find(t2);
    $[5] = condition?.property;
    $[6] = properties;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const conditionProperty = t1;
  let t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      slotProps: {
        paper: {
          sx: {
            maxHeight: "unset"
          }
        }
      }
    };
    t3 = {
      ...inlineDropdownStyle,
      fontWeight: "medium",
      height: "100%"
    };
    $[10] = t2;
    $[11] = t3;
  } else {
    t2 = $[10];
    t3 = $[11];
  }
  const t4 = conditionProperty ?? "";
  let t5;
  if ($[12] !== condition || $[13] !== onChange) {
    t5 = event => {
      const property = event.target.value as FilterProperty;
      onChange({
        ...condition,
        property: property.name,
        operator: Object.keys(OPERATORS[property.policyRelation ?? PropertyPolicyRelation.MultipleValues])?.[0],
        value: []
      });
    };
    $[12] = condition;
    $[13] = onChange;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== properties) {
    let t7;
    if ($[17] !== properties.length) {
      t7 = (group, gi) => group.map((p, i) => i === group.length - 1 && gi < properties.length - 1 ? [<MenuItem key={p.name} value={p as never}>{p.condition?.displayName ?? p.displayName}</MenuItem>, <Divider key={`${p.name}divider`} className="my-[8px]" />] : [<MenuItem key={p.name} value={p as never}>{p.condition?.displayName ?? p.displayName}</MenuItem>]);
      $[17] = properties.length;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    t6 = properties.map(t7).flat();
    $[15] = properties;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[19] !== props || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <Select MenuProps={t2} sx={t3} value={t4} onChange={t5} {...props}>{t6}</Select>;
    $[19] = props;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}